import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  padding: 0 5px;
  height: 100%;

  svg {
    cursor: pointer;
    color: ${RacemapColors.DarkGray};

    :hover {
      filter: unset;
    }
  }
`;
